import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => {
  return {
    root: {
      ...theme.shape.componentSpacing,
      '& .heading': {
        [theme.breakpoints.up('lg')]: {
          marginBottom: theme.spacing(5),
        },
      },
      '& .listingDescription': {
        color: theme.palette.text.darkGrey,
        marginBottom: theme.spacing(3),
        [theme.breakpoints.down('md')]: {
          marginTop: theme.spacing(-2),
        },
      },
    },
  };
});

export default useStyles;
